// Copyright Koninklijke Philips N.V. 2024

import { Spinner } from '@filament/react/spinner';
import { Paragraph } from '@filament/react/text';
import * as styles from './Loading.css';

type LoadingProps = {
    text?: string;
    fullScreen?: boolean;
}

export const Loading = ({ text, fullScreen }: LoadingProps) => (
    <div className={fullScreen ? styles.loadingFullScreen : styles.loading}>
        <Spinner size="normal" />
        <Paragraph>{text ?? 'Loading...'}</Paragraph>
    </div>
);
